import React from "react"

const SocialIconWebsite = ({
  className = "",
  width = "auto",
  height = "auto",
  fill,
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m4.235 4.453c-1.27496 1.32329-2.0555 3.04515-2.21043 4.87617-.15493 1.83103.3252 3.65953 1.35969 5.17823 1.03448 1.5187 2.56025 2.635 4.32085 3.1612s3.64869.4303 5.34689-.2716c.115-.75-.137-1.47-.24-1.722-.23-.56-.988-1.517-2.253-2.844-.338-.355-.316-.628-.195-1.437l.013-.091c.082-.554.22-.882 2.085-1.178.948-.15 1.197.228 1.542.753l.116.172c.328.48.571.59.938.756.165.075.37.17.645.325.652.373.652.794.652 1.716v.105c0 .391-.038.735-.098 1.034.7674-.9631 1.3021-2.0903 1.5626-3.2938.2605-1.2036.2397-2.45098-.0608-3.64517-.3004-1.19419-.8725-2.30293-1.6715-3.23989-.799-.93697-1.8035-1.67688-2.9353-2.16214-.553.373-1.312.902-1.577 1.265-.135.185-.327 1.132-.95 1.21-.162.02-.381.006-.613-.009-.622-.04-1.472-.095-1.744.644-.173.468-.203 1.74.356 2.4.09.105.107.3.046.519-.08.287-.241.462-.292.498-.096-.056-.288-.279-.419-.43-.313-.365-.705-.82-1.211-.96-.184-.051-.386-.093-.583-.135-.549-.115-1.17-.246-1.315-.554-.106-.226-.105-.537-.105-.865 0-.417 0-.888-.204-1.345-.07092-.16309-.17515-.30956-.306-.43zm5.765 15.547c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10-4.477 10-10 10z"
        fill={fill}
      />
    </svg>
  )
}

export default SocialIconWebsite
